import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getOpportunityStatuses = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/opportunity_statuses?' + params.toString()); // Let the error bubble up
};

const getOpportunityStatusById = async (id: number) => {
  return await apiClient.get(`/opportunity_statuses/${id}`); // Fetch car listing by ID
};

const createOpportunityStatus = async (opportunityData: any) => {
  return await apiClient.post('/opportunity_statuses', opportunityData); // Create a new car listing
};

const updateOpportunityStatus = async (id: number, opportunityData: any) => {
  return await apiClient.patch(`/opportunity_statuses/${id}`, opportunityData); // Update car listing by ID
};

const deleteOpportunityStatus = async (id: number) => {
  return await apiClient.delete(`/opportunity_statuses/${id}`); // Delete car listing by ID
};

export default {
  getOpportunityStatuses,
  getOpportunityStatusById,
  createOpportunityStatus,
  updateOpportunityStatus,
  deleteOpportunityStatus
};
